// On document loaded, focus on the first input of the first gravityform on a page.
document.addEventListener("DOMContentLoaded", function() {
    const form = document.querySelector('main .gform_wrapper form');

    if (form === null) {
        return;
    }

    const autoFocusDisabled = form.dataset['autofocusDisabled'] === "true";

    if (autoFocusDisabled) {
        return;
    }

    const isNewsletterForm = form.closest('.newsletter-form') !== null;

    if (isNewsletterForm) {
        return;
    }

    form.querySelector('input').focus();
});


// WEBPACK FOOTER //
// ./scripts/custom/autofocus-on-gravity-forms.js